

interface BackgroundPanelProps {
  hdriOptions: Array<{ id: string; name: string; url: string }>;
  onHdriChange: (url: string) => void;
  onSceneryChange: (visible: boolean) => void;
}

export const BackgroundPanel = ({ hdriOptions, onHdriChange, onSceneryChange }: BackgroundPanelProps) => {
  return (
    <div class="visualizer-panel visualizer-bg-panel">
      <div class="visualizer-panel-title">Scene</div>

      {hdriOptions.length > 0 && (
        <div class="visualizer-panel-section">
          <label class="visualizer-panel-label">Environment</label>
          <select
            class="visualizer-select"
            onChange={(e) => onHdriChange((e.target as HTMLSelectElement).value)}
          >
            {hdriOptions.map(opt => (
              <option key={opt.id} value={opt.url}>
                {opt.name}
              </option>
            ))}
          </select>
        </div>
      )}

      <div class="visualizer-panel-section">
        <label class="visualizer-toggle-item">
          <input
            type="checkbox"
            class="visualizer-toggle-checkbox"
            onChange={(e) => onSceneryChange((e.target as HTMLInputElement).checked)}
          />
          <span class="visualizer-toggle-label">Show Scenery</span>
        </label>
      </div>
    </div>
  );
};
